// noinspection JSCheckFunctionSignatures,EqualityComparisonWithCoercionJS,JSUnresolvedVariable,JSIgnoredPromiseFromCall,PointlessBooleanExpressionJS
// noinspection EqualityComparisonWithCoercionJS

import {MAX_PARENT_TRAVERSAL_FOR_FEEDBACK} from "./forms";

// TODO: Redo everything
let defaultError = 'Something went wrong, please try again later';

export default function handleAjaxErrorV2(error, form = null) {
    // Default function for handling an ajax error, displays a sweet alert popup with the error.

    // If jquery response
    const response = error;
    if (response.responseJSON && response.responseJSON.errors != undefined && form) {
        $.each(response.responseJSON.errors, function (k, v) {
            if (form.find('#' + k).length) {
                // noinspection JSCheckFunctionSignatures
                form.find('#' + k).addClass('is-invalid').parents('.form-group')
                    .find('.invalid-feedback').text(v.join('. '));

                const element = form.find('#' + k)[0];
                window.scrollToElementNative(element);
            } else {
                // Try finding as an input array
                const isArray = k.includes('.');
                if (isArray) {
                    const inputArrayName = k.split('.')[0];
                    const index = k.split('.')[1];

                    form.find(`input[name^="${inputArrayName}"],select[name^="${inputArrayName}"]`).each((_index, element) => {
                        if (index == _index) {
                            $(element).addClass('is-invalid').parents('.form-group')
                                .find('.invalid-feedback').text(v.join('. ').replace(k, inputArrayName));
                            window.scrollToElementNative(element);
                        }
                    })

                } else {
                    Swal.fire({
                        icon: 'error',
                        html: v[0],
                    });
                }
            }
        })
    } else if (response.responseJSON && response.responseJSON.message) {
        Swal.fire({
            icon: 'error',
            html: response.responseJSON.message != undefined ? response.responseJSON.message : defaultError
        });
    }

    // If normal response
    else if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        if (error.response.data.errors && Object.values(error.response.data.errors)[0] && Object.values(error.response.data.errors)[0][0]) {
            console.log(error.response.data.errors);
            // Look for fields with name for errors
            let fieldFound = false;
            Object.keys(error.response.data.errors).forEach(field => {
                const mayBeArray = field.split('.')[1];

                const errors = error.response.data.errors[field];
                let container = document;
                if (form) {
                    container = form;
                }

                if (mayBeArray && field.match(/\.?(\d+)\./)) {
                    // Assume array
                    const index = field.match(/\.?(\d+)\./)[1];
                    const actualField = field.match(/\.([^.]*)$/)[1];

                    container.querySelectorAll(`input[name="${actualField}"],textarea[name="${actualField}[]"]`).forEach((fieldElement, _index) => {
                        if (_index == index) {
                            displayFeedback(fieldElement, errors[0]);

                            window.scrollToElementNative(fieldElement);

                            fieldFound = true;
                        }
                    });

                } else if (mayBeArray && field.match(/\.?(\d+)/)) {
                    // Assume simple array with form 'field[]'

                    const index = field.match(/\.?(\d+)/)[1];
                    const actualField = field.match(/([^.]*)\./)[1];

                    container.querySelectorAll(`input[name="${actualField}[]"],textarea[name="${actualField}[]"],select[name="${actualField}[]"]`).forEach((fieldElement, _index) => {
                        if (_index == index) {
                            fieldElement.classList.add('is-invalid');

                            // Attempt to fix field name if needed
                            let error = errors[0];
                            error = error.replace(field, actualField);

                            displayFeedback(fieldElement, error);

                            window.scrollToElementNative(fieldElement);

                            fieldFound = true;
                        }
                    });
                } else {
                    const actualField = field;
                    container.querySelectorAll(`input[name="${actualField}"],textarea[name="${actualField}"],select[name="${actualField}"]`).forEach((fieldElement, _index) => {
                        displayFeedback(fieldElement, errors[0]);

                        window.scrollToElementNative(fieldElement);
                        fieldFound = true;
                    });
                }
            })
            if (!fieldFound) {
                Swal.fire({
                    icon: 'error',
                    html: Object.values(error.response.data.errors)[0][0], // First error of the first field
                })
            }
        } else {
            if (error.response.data.message) {
                console.log(error.response.data)

                Swal.fire({
                    icon: 'error',
                    html: error.response.data.message, // First error of the first field
                })
            } else if (error.response.data.error) {
                console.log(error.response.data)

                Swal.fire({
                    icon: 'error',
                    html: error.response.data.error, // First error of the first field
                })
            } else {
                console.log(error.response.data)

                Swal.fire({
                    icon: 'error',
                    html: defaultError,
                })
            }
        }
    } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
        Swal.fire({
            icon: 'error',
            html: defaultError,
        })
    } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error);
        Swal.fire({
            icon: 'error',
            html: defaultError,
        })
    }


    /**
     * Methods
     */

    /**
     *
     * @param {Element} element
     * @param {string} feedback
     */
    function displayFeedback(element, feedback) {
        element.classList.add('is-invalid');

        // Search for feedback container
        let parentsTraversed = 1
        while (element.parentElement) {
            if (parentsTraversed > MAX_PARENT_TRAVERSAL_FOR_FEEDBACK) {
                break;
            }
            const feedbackContainer = element.parentElement.querySelector('.invalid-feedback');

            if (feedbackContainer) {
                feedbackContainer.innerText = feedback;

                // Make visible if not on the same container as input
                feedbackContainer.classList.add('d-block');

                break;
            }

            // Not found, get next parent
            element = element.parentElement;
            parentsTraversed++;
        }
    }
}
